import { Container } from "./style";

import { Layout } from "../../components/Layout";
import { Button } from "../../components/Button";

import { CaretLeft, CaretRight } from "phosphor-react";
import { useEffect, useState } from "react";
import api from "../../services/api";

import { useAuth } from "../../contexts/Auth";
import { useDate } from "../../contexts/Date";
import { useSchedulle } from "../../contexts/Schedulle";

import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import axios from "axios";
import LanguageSelector from "../../components/LanguageSelector";
import loadingGif from '../../assets/gifs/loading.gif';

const formatTime = (time) => {
  return `${new Date(time).getHours()}:${
    new Date(time).getMinutes() <= 9
      ? "0" + new Date(time).getMinutes()
      : new Date(time).getMinutes()
  }`;
};

const formatDate = (date) => {
  return `${date.getFullYear()}-${
    date.getMonth() + 1 <= 9
      ? "0" + String(date.getMonth() + 1)
      : date.getMonth() + 1
  }-${date.getDate() <= 9 ? "0" + String(date.getDate()) : date.getDate()}`;
};

export const Schedule = () => {
  const { t } = useTranslation();
  const { token } = useAuth();
  const { historic, setHistoric } = useDate();
  const { setSchedulle, response, setResponse } = useSchedulle();
  const navigate = useNavigate();
  const { language } = useParams();

  const [currentDate, setCurrentDate] = useState(formatDate(new Date()));
  const [nextDays, setNextDays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSlot, setCurrentSlot] = useState([]);
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedFormatedTime, setSelectedFormatedTime] = useState("");
  const [setError] = useState();
  const [availableSlots, setAvailableSlots] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [waitingSubmitRequest, setWaitingSubmitRequest] = useState(false);

  const months = [
    t('utils.monthsAbbr.january'),
    t('utils.monthsAbbr.february'),
    t('utils.monthsAbbr.march'),
    t('utils.monthsAbbr.april'),
    t('utils.monthsAbbr.may'),
    t('utils.monthsAbbr.june'),
    t('utils.monthsAbbr.july'),
    t('utils.monthsAbbr.august'),
    t('utils.monthsAbbr.september'),
    t('utils.monthsAbbr.october'),
    t('utils.monthsAbbr.november'),
    t('utils.monthsAbbr.december')
  ];

  const daysOfWeek = [
    t('utils.weekDaysAbbr.sunday'),
    t('utils.weekDaysAbbr.monday'),
    t('utils.weekDaysAbbr.tuesday'),
    t('utils.weekDaysAbbr.wednesday'),
    t('utils.weekDaysAbbr.thursday'),
    t('utils.weekDaysAbbr.friday'),
    t('utils.weekDaysAbbr.saturday')
  ];

  // aplicar formatacao
  const formatacaoVisualDate = (currentDate) => {
    const elemento = document.getElementById(currentDate);
    const elementoPai = document.getElementById("schedule-days-week");

    elementoPai.childNodes.forEach((filho) => {
      if (filho.classList.contains("isSelected")) {
        filho.classList.toggle("isSelected");
      }
    });

    if (elemento) {
      elemento.classList.toggle("isSelected");
    }
  };

  const formatacaoVisualTime = (id) => {
    const elemento = document.getElementById(id);

    const elementoPai = document.getElementById("schedule-hours");

    elementoPai.childNodes.forEach((filho) => {
      if (filho.classList.contains("isSelected")) {
        filho.classList.toggle("isSelected");
      }
    });

    elemento.classList.toggle("isSelected");
  };

  // BUSCAR DADO NO HISTÓRICO
  const searchData = (data) => {
    return historic.find((item) => item?.date === data);
  };

  // PROXIMAS DATAS DO DISPLAY
  const getNextDates = async (currentDate) => {
    let dates = [];

    let base = new Date(currentDate);

    for (let i = 0; i <= 4; i++) {
      dates.push(new Date(base.setDate(base.getDate() + 1)));
    }

    setNextDays(dates);
  };

  const forwardDates = async () => {
    if (loading) return;
    
    let dates = [];

    let base = new Date(nextDays[4]);

    for (let i = 0; i <= 4; i++) {
      dates.push(new Date(base.setDate(base.getDate() + 1)));
    }

    setNextDays(dates);

    let novaCurrentData = formatDate(
      new Date(nextDays[4].setDate(nextDays[4].getDate() + 1))
    );

    await handleSelectDay({ currentTarget: { id: novaCurrentData }});
    setCurrentDate(novaCurrentData);
  };

  const backwardDates = () => {
    if (loading) return;
    
    let dates = [];

    let base = nextDays[0];

    for (let i = 0; i <= 4; i++) {
      dates.push(new Date(base.setDate(base.getDate() - 1)));
    }

    let date = [];

    for (let i = dates.length; i >= 0; i--) {
      if (dates[i]) {
        date.push(dates[i]);
      }
    }

    setNextDays(date);
    const novaCurrentData = formatDate(date[0]);
    setCurrentDate(novaCurrentData);
    handleSelectDay({ currentTarget: { id: novaCurrentData }});
  };

  // formatar DADO RECEBIDO DA API
  const formatacaoTimeSlots = (dadosRecebidos) => {
    let dados = [];

    dadosRecebidos.forEach((dadoRecebido) => {
      let dados_item = [];

      if (dadoRecebido.slots.length > 0) {
        dadoRecebido.slots.forEach((slot) => {
          let data = new Date(slot.time);

          var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
          var localISOTime = new Date(data - tzoffset)
            .toISOString()
            .slice(0, -1);

          dados_item.push({ ...slot, formated_time: formatTime(localISOTime) });
        });

        dados.push({ ...dadoRecebido, slots_to_display: dados_item });
      } else {
        dados.push({ ...dadoRecebido, slots_to_display: dados_item });
      }
    });

    return dados;
  };

  const handleSelectDay = async (e) => {
    setLoading(true);
    formatacaoVisualDate(e.currentTarget.id);

    const data = String(e.currentTarget.id);

    let informacao = searchData(data);

    if (informacao) {
      setCurrentSlot(informacao);
    } else {
      let dadosAPI = [...historic];

      let dado = await api
        .get(`/available_slots?start_date=${data}`, {
          headers: {
            Authorization: `Bearer ${token?.token}`,
          },
        })
        .then((response) => {
          let dadoFormatado = formatacaoTimeSlots(response.data);
          const currentDadoFormatado = dadoFormatado.find((dado) => dado.date === data);
          setCurrentSlot(currentDadoFormatado);
          return dadoFormatado;
        });

      dadosAPI.push(...dado);

      setHistoric(dadosAPI);
    }

    setLoading(false);
  };

  const handleSelectHour = (e) => {
    setSelectedTime(e.currentTarget.id);
    setSelectedFormatedTime(e.currentTarget.innerText);

    formatacaoVisualTime(e.currentTarget.id);

    window.scrollTo(0, document.body.scrollHeight);
  };

  const handleSelection = async () => {
    if (waitingSubmitRequest) return;
    setWaitingSubmitRequest(true);

    if (token?.token === undefined) {
      navigate(`/${language}`);
    }

    const info = {
      current_date: currentDate,
      selected_time: selectedTime,
      time_formated: selectedFormatedTime,
    };

    var postData = {
      start_datetime: selectedTime,
    };

    let axiosConfig = {
      headers: {
        Authorization: `Bearer ${token?.token}`,
      },
    };


    let res = await axios
      .post(`${process.env.REACT_APP_API}/bookings`, postData, axiosConfig)
      .then((res) => {
        setWaitingSubmitRequest(false);
        return res.data;
      })
      .catch((err) => {
        setWaitingSubmitRequest(false);
        return err;
      });

      
    setResponse(res);
    setSchedulle(info);
  };

  const getAvailableSlots = async () => {
    await api
        .get(`/available_slots?start_date=${formatDate(new Date())}`, {
          headers: {
            Authorization: `Bearer ${token?.token}`,
          },
        })
        .then((response) => {
          setAvailableSlots(response.data);
        });
  }

  // Verify if user is logged in
  useEffect(() => {
    if (token?.token === undefined) {
      navigate(`/${language}`);
    } else {
      getAvailableSlots();
      getNextDates(currentDate);
    }
  }, []);

  useEffect(() => {
    if (firstLoading && availableSlots.length !== 0) {
      setFirstLoading(false);

      let dadoFormatado = formatacaoTimeSlots(availableSlots);
      setCurrentSlot(dadoFormatado[0]);
      formatacaoVisualDate(dadoFormatado[0].date);
      setHistoric(dadoFormatado);
      setLoading(false);
    }
  }, [availableSlots]);

  useEffect(() => {
    if (!firstLoading && availableSlots.length !== 0) {
      setLoading(true);
      
      const updateCurrentDate = async () => {
        formatacaoVisualDate(currentDate);
        const data = String(currentDate);
        const buscaNoHistorico = await searchData(currentDate);
  
        if (buscaNoHistorico) {
          setCurrentSlot(buscaNoHistorico);
        } else {
          let dadosHistoricos = [...historic];
  
          await api
            .get(`/available_slots?start_date=${data}`, {
              headers: {
                Authorization: `Bearer ${token?.token}`,
              },
            })
            .then((response) => {
              let dadoFormatado = formatacaoTimeSlots(response.data);
              setCurrentSlot(dadoFormatado[0]);
              dadosHistoricos.push(...dadoFormatado);
              setHistoric(dadosHistoricos);
            });
        }
        setLoading(false);
      };
      updateCurrentDate();
    }
  }, [currentDate]);

  useEffect(() => {
    if (response) {
      if (response.hasOwnProperty("coach")) {
        navigate(`/${language}/confirmation`);
      } else if (response.hasOwnProperty("error")) {
        if (response.error === "appointment_in_progress") {
          navigate(`/${language}/error`);
        } else {
          setError(response.error);
        }
      }
    }
  }, [response]);

  return (
    <>
      <Layout>
        <Container disableDayDiv={loading}>
          <div className="topBar"></div>
          <div className="schedule">
            <h1>
              {t('schedulePage.title')}
            </h1>

            <div className="schedule-container">
              <div className="schedule-controlles">
                <button disabled={loading} onClick={() => backwardDates()}>
                  <CaretLeft />
                </button>

                <p>{`${nextDays[0]?.getDate()} - ${nextDays[4]?.getDate()} ${t('schedulePage.datePreposition')} ${
                  months[nextDays[4]?.getMonth()]
                } ${t('schedulePage.datePreposition')} ${nextDays[4]?.getFullYear()}`}</p>

                <button disabled={loading} onClick={(e) => forwardDates(e)}>
                  <CaretRight />
                </button>
              </div>

              <div className="schedule-days-week" id="schedule-days-week">
                {nextDays?.map((date, index) => {
                  return (
                    <div
                      className={"day"}
                      key={index}
                      disabled={loading}
                      id={formatDate(date)}
                      onClick={(e) => {
                        if (loading) return;
                        handleSelectDay(e);
                      }}
                    >
                      <p>{daysOfWeek[date?.getDay()]}</p>
                      <p>{date?.getDate()}</p>
                    </div>
                  );
                })}
              </div>

              <div className="schedule-hours" id="schedule-hours">
                {loading ? (
                  <div className="loading">
                    <img src={loadingGif} alt="loading..." />
                    <p>{t('schedulePage.loading')}</p>
                    </div>
                ) : currentSlot?.slots_to_display.length > 0 ? (
                  currentSlot?.slots_to_display.map((item) => {
                    return (
                      <button
                        key={item.formated_time}
                        data_time={item.formated_time}
                        disabled={!item.is_enabled ? true : false}
                        id={item.time}
                        onClick={(e) => handleSelectHour(e)}
                      >
                        {item.formated_time}
                      </button>
                    );
                  })
                ) : (
                  <div className="unavailable">
                    <p>{t('schedulePage.unavailable')}</p>
                  </div>
                )}
              </div>
            </div>

            <Button label={t('schedulePage.action').toUpperCase()} evt={handleSelection} />
          </div>

          <LanguageSelector />
        </Container>
      </Layout>
    </>
  );
};
